import { loaderAction, allWorkoutsCountAction, paginationAction, workoutsAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { api } from "../../helpers/api";
import { setLocalStorage } from "../../helpers/LocalStorage";

export const GetWorkoutsThunk = (args) => async (dispatch, getState) => {
    const { user, currentEstablishment } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('establishment', currentEstablishment);
        formData.append('page', args?.page || 1);
        formData.append('date_from', args?.from || '');
        formData.append('date_to', args?.to || '');
        formData.append('subscription_type', args?.subscription_type || '');
        formData.append('subscription_coach', args?.subscription_coach || '');
        formData.append('subscription_constraints', args?.subscription_constraints || '');
        formData.append('subscription_workouts_count', args?.subscription_workouts_count || '');
        formData.append('filter_user', args?.filter_user || '');
        formData.append('one_time', args?.oneTime || '0');
        formData.append('debt_workouts', args?.debtWorkouts || '0');

        const response = await api({ data: formData, link: 'get_workouts' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            dispatch(workoutsAction(response.workouts));
            dispatch(paginationAction(response.pagination));
            dispatch(allWorkoutsCountAction(response.all_workouts_count));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        dispatch(loaderAction(false));
    }
    finally {
        dispatch(loaderAction(false));
    }
};